




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ActivityStatus from '@/models/Activities/ActivityStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';

@Component({
  name: 'ActivityStatusDisplay',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status!: ActivityStatus;

	@Prop({required: true})
	location!: StatusDisplayLocation;

	get textColor() {
		let color = "grey--text";
		switch (this.status) {
			case ActivityStatus.Draft:
				color = "orange--text";
				break;
			case ActivityStatus.Planned:
				color = "blue--text";
				break;
			case ActivityStatus.Completed:
				color = "green--text";
				break;
			case ActivityStatus.Cancelled:
				color = "grey--text";
				break;
			default:
				color = "grey--text";
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case ActivityStatus.Draft:
				text = "DRAFT";
				break;
			case ActivityStatus.Planned:
				text = "PLANNED";
				break;
			case ActivityStatus.Completed:
				text = "COMPLETED";
				break;
			case ActivityStatus.Cancelled:
				text = "CANCELLED";
				break;
			default:
				text = "UNKNOWN";
				break;
		}
		return text;
	}

	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
